import type { CSSProperties } from 'react';
import { useState } from 'react';

import Sidebar from '../components/Sidebar';
import { T } from '../styles/tokens';

const faqs = [
  { q: 'Как получить конфиг после оплаты?', a: 'Сразу после подтверждения платежа бот пришлёт конфиг в Telegram и он станет доступен в личном кабинете на вкладке «Подписки».' },
  { q: 'Сколько устройств можно подключить?', a: 'Вы можете создать несколько подписок одного протокола — по одной на каждое устройство. Перемещать один конфиг между устройствами нельзя.' },
  { q: 'Что выбрать: WireGuard или VLESS?', a: 'WireGuard — для скорости и стабильности. VLESS Reality — если WireGuard не работает или хотите обход DPI. Лучший вариант — купить оба.' },
  { q: 'Не подключается VLESS, что делать?', a: 'Проверьте, что приложение (v2rayNG, Streisand, Hiddify) обновлено до последней версии. Скопируйте ссылку заново из бота или личного кабинета — иногда ключ ротируется.' },
  { q: 'Можно ли вернуть деньги?', a: 'Да, если подписка была активирована менее 24 часов назад и вы её не использовали. Напишите в поддержку @xelllinson.' },
];

export default function Support() {
  const [form, setForm] = useState({ topic: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => {
      setSent(false);
      setForm({ topic: '', message: '' });
    }, 2500);
  };

  return (
    <div style={sp.root}>
      <Sidebar active="support" />
      <main style={sp.main}>
        <div style={sp.topBar}>
          <div>
            <div style={sp.pageTag}>// помощь</div>
            <div style={sp.pageTitle}>Поддержка</div>
          </div>
        </div>

        <div style={sp.contactsRow}>
          <a href="https://t.me/xelllinson" target="_blank" rel="noreferrer" style={sp.contactCard}>
            <div style={sp.contactTag}>Telegram</div>
            <div style={sp.contactName}>@xelllinson</div>
            <div style={sp.contactHint}>Среднее время ответа: 15 мин</div>
          </a>
          <a href="https://t.me/vpnsalerpy_bot" target="_blank" rel="noreferrer" style={sp.contactCard}>
            <div style={sp.contactTag}>Telegram Bot</div>
            <div style={sp.contactName}>@vpnsalerpy_bot</div>
            <div style={sp.contactHint}>Управление подписками</div>
          </a>
        </div>

        <div style={sp.faqLabel}>// частые вопросы</div>
        <div style={sp.faqList}>
          {faqs.map((f, i) => (
            <Faq key={i} q={f.q} a={f.a} />
          ))}
        </div>

        <div style={sp.formCard}>
          <div style={sp.formLabel}>// написать нам</div>
          <form onSubmit={submit} style={sp.form}>
            <input
              type="text"
              value={form.topic}
              onChange={(e) => setForm({ ...form, topic: e.target.value })}
              placeholder="Тема"
              required
              style={sp.input}
            />
            <textarea
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Опишите проблему..."
              required
              rows={5}
              style={{ ...sp.input, resize: 'vertical', fontFamily: 'DM Sans, sans-serif' }}
            />
            <button type="submit" style={sp.ctaBtn}>
              {sent ? '✓ Отправлено' : 'Отправить'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

function Faq({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={sp.faqItem}>
      <button style={sp.faqQ} onClick={() => setOpen(!open)}>
        <span>{q}</span>
        <span style={{ fontFamily: 'DM Mono, monospace', color: T.accent }}>{open ? '−' : '+'}</span>
      </button>
      {open && <div style={sp.faqA}>{a}</div>}
    </div>
  );
}

const sp: Record<string, CSSProperties> = {
  root: { display: 'flex', minHeight: '100vh', background: T.bg, fontFamily: 'DM Sans, sans-serif', color: T.text },
  main: { flex: 1, marginLeft: 220, padding: '36px 44px', boxSizing: 'border-box', maxWidth: 'calc(100vw - 220px)' },
  topBar: { marginBottom: 32 },
  pageTag: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.accent, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 6 },
  pageTitle: { fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 28, letterSpacing: '-0.03em', color: T.text },
  contactsRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 36 },
  contactCard: { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 4, padding: '22px 24px', textDecoration: 'none', color: T.text, cursor: 'pointer', transition: 'border-color 0.15s' },
  contactTag: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.accent, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 },
  contactName: { fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 18, letterSpacing: '-0.02em', marginBottom: 4 },
  contactHint: { fontSize: 12, color: T.textSec },
  faqLabel: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.textMuted, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 14 },
  faqList: { border: `1px solid ${T.border}`, borderRadius: 4, overflow: 'hidden', marginBottom: 36, background: T.surface },
  faqItem: { borderBottom: `1px solid ${T.border}` },
  faqQ: { width: '100%', background: 'none', border: 'none', color: T.text, fontFamily: 'DM Sans, sans-serif', fontSize: 14, fontWeight: 600, cursor: 'pointer', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign: 'left' },
  faqA: { padding: '0 20px 18px', color: T.textSec, fontSize: 13, lineHeight: 1.7 },
  formCard: { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 4, padding: '22px 24px' },
  formLabel: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.textMuted, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 14 },
  form: { display: 'flex', flexDirection: 'column', gap: 10 },
  input: { background: T.surfaceUp, border: `1px solid ${T.border}`, borderRadius: 3, padding: '11px 14px', color: T.text, fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none' },
  ctaBtn: { background: T.accent, border: 'none', borderRadius: 4, padding: '12px 22px', color: '#000', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', alignSelf: 'flex-start' },
};
